// extracted by mini-css-extract-plugin
export default {"formContainer":"Settings_formContainer__5Ztkj"};